import React, { Component } from 'react';
import { DisplayProduct } from './product';
import { priceTag, qohTag } from './tags';
import { formatIntCurrency } from '../../helpers/format';
import { Hit } from '../../rpc/admin/search_pb';
import { Supplier } from '../../rpc/admin/suppliers_pb';
import { Link } from 'react-router-dom';

class OverviewProps {
    product?: DisplayProduct;
    supplierProducts: Hit[] = [];
    manufacturerFilterPrefix?: string;
}

class OverviewState {}

class Overview extends Component<OverviewProps, OverviewState> {

    render() {
        if (!this.props.product) {
            return <></>;
        }

        const priceTagClass = priceTag(this.props.product?.price, this.props.supplierProducts);
        const qohTagClass = qohTag(Supplier.SUPPLIER_UNKNOWN, this.props.product?.qoh, this.props.supplierProducts);

        return (
            <div className="product-head">
                <div className="product-head-content">
                    <div className="product-head-title">
                        {this.props.product?.title}
                    </div>
                    <div className="product-head-manufacturer">by&nbsp;
                        <Link to={this.props.manufacturerFilterPrefix + encodeURIComponent('=' + this.props.product?.manufacturer)}>
                            {this.props.product?.manufacturer}
                        </Link>
                    </div>
                    <div className="product-head-price">
                        <span className={priceTagClass}>{formatIntCurrency(this.props.product?.price)}</span>
                    </div>
                    {this.props.product?.msrp ? (
                        <div className="product-head-msrp">
                            MSRP: {formatIntCurrency(this.props.product?.msrp)}
                        </div>
                    ) : ''}
                    {this.props.product?.mapp ? (
                        <div className="product-head-mapp">
                            MAPP: {formatIntCurrency(this.props.product?.mapp)}
                        </div>
                    ) : ''}
                    <div className="product-head-qoh">
                        QOH: <span className={qohTagClass}>{this.props.product?.qoh}</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default Overview;
